import LoadingSpinner from "@app/shared/LoadingSpinner";
import { FlyoutContext, FlyoutFooter } from "@app/shared/Flyouts";
import { JSX, useContext } from "react";
import Project from "@app/projects/project";
import { QESButton } from "@app/shared/qes-standards/Button";

interface MemberSetArchiveFlyoutProps {
  onSubmit: () => void;
  associatedProjects: Project[];
  loadingProjects: boolean;
}

const MemberSetArchiveFlyout = (props: MemberSetArchiveFlyoutProps): JSX.Element => {
  const flyoutContext = useContext(FlyoutContext);

  const handleSubmit = () => {
    flyoutContext.handleCloseFlyout().then(() => {
      props.onSubmit();
    });
  };

  const renderBlockedProjects = () => {
    return props.associatedProjects.map((project) => {
      return (
        <li key={project.projectId}>
          {project.resource.name}
        </li>
      );
    });
  };

  const renderCanArchive = () => {
    return (
      <>
        <p className="d-flex">
          <span className="icon-container">
            <i className="fa fa-check me-2 text-success" />
          </span>
          <span>
            There are no projects associated with this member population. You may proceed with archiving.
          </span>
        </p>
      </>
    );
  };

  const renderCantArchive = () => {
    return (
      <>
        <p className="d-flex">
          <span className="icon-container">
            <i className="fa fa-times me-2 text-danger" />
          </span>
          <span>This member population must be disassociated with the following projects, before it can be archived:</span>
        </p>
        <ul>
          {renderBlockedProjects()}
        </ul>
      </>
    );
  };

  return (
    <>
      {props.loadingProjects ? <LoadingSpinner /> : (
        <div>
          {props.associatedProjects.length === 0 ? renderCanArchive() : renderCantArchive()}
          <FlyoutFooter
            submitButton={<QESButton qesTestId="member-set-archive-flyout_archive" qesType="primary-danger" disabled={!(props.associatedProjects.length === 0)} className="mb-3" onClick={handleSubmit}>Archive</QESButton>}
          />
        </div>
      )}
    </>
  );
};

export default MemberSetArchiveFlyout;
